import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

/**
 * Applique une date de commande en masse aux commandes sélectionnées.
 */
export const BulkOrderDateDialog = ({
  open,
  onOpenChange,
  selectedCount,
  bulkDate,
  setBulkDate,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="bulk-date-dialog">
        <DialogHeader>
          <DialogTitle>Appliquer une date de commande</DialogTitle>
          <DialogDescription>
            La date choisie sera appliquée aux <strong>{selectedCount}</strong> commande
            {selectedCount > 1 ? "s" : ""} sélectionnée{selectedCount > 1 ? "s" : ""}. Les valeurs existantes seront écrasées.
          </DialogDescription>
        </DialogHeader>
        <div className="py-3 space-y-2">
          <Label>Date de commande</Label>
          <Popover>
            <PopoverTrigger asChild>
              <Button
                type="button"
                variant="outline"
                className="w-full justify-start text-left font-normal"
                data-testid="bulk-date-picker"
              >
                <CalendarIcon className="mr-2 h-4 w-4" />
                {bulkDate
                  ? format(bulkDate, "dd MMMM yyyy", { locale: fr })
                  : <span className="text-muted-foreground">Sélectionner une date</span>}
              </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start">
              <Calendar
                mode="single"
                selected={bulkDate}
                onSelect={(d) => setBulkDate(d || null)}
                locale={fr}
                initialFocus
              />
            </PopoverContent>
          </Popover>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
          <Button
            onClick={onConfirm}
            disabled={!bulkDate}
            data-testid="bulk-date-confirm-btn"
          >
            Appliquer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BulkOrderDateDialog;
